import React, { Component } from 'react';
import * as moment from 'moment';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import Status from '../../../../config/OrderStatusConstants.js'
import { Button, Divider, Icon, Header } from 'semantic-ui-react'
import { getOrderKey, logDashboardAction} from '../../../../config/constants';

export class MarkEmbroidery extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    markEmbroidery = () => {
        console.log("funk1 ++++: markEmbroidery");
        console.log("funk12 email:" + this.props.user.email);
        //console.log("funk13 status:" + this.props.status);

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {}

        let dashboardLogString = "none";
        let updateText = "non"

        if (this.props.order.embroidery && this.props.order.embroidery == 'embroidery') {
            console.log("funk14 this.props.order.embroidery:" + this.props.order.embroidery)
            orderUpdates = {
                embroidery: "embroidery_off",
                embroidery_lastUpdate: now,
            }

            dashboardLogString = this.props.user.email+ " removed embroidery to "+this.props.order.order_num;
            updateText = "removed embroidery - "+this.props.user.email.substring(0,10);
        } else {
            orderUpdates = {
                embroidery: "embroidery",
                embroidery_lastUpdate: now,
                // whatsApp_avail: true
            }

            dashboardLogString = this.props.user.email+ " added embroidery from "+this.props.order.order_num;
            updateText = "added embroidery - "+this.props.user.email.substring(0,10);
        }

        //FbUtils.updateOrder(this.props.order.key, orderUpdates);
        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        
        console.log("nxtb12 updateString:"+dashboardLogString);
        logDashboardAction(dashboardLogString, this.props.user.email, this.props.order.order_num,"embroidery");
        console.log("nxtb13 updateString after logDashboardAction");

        FbUtils.insertUpdateText(this.props.order.key, updateText, this.props.user.email);
    }

    render() {


        const showEmbroideryButtons = this.props.order.embroidery && this.props.order.embroidery == 'embroidery'
            ? <div>
                <Header as='h3'>
                    <Icon name='won' />
                    <Header.Content>ORDER MARKED FOR EMBROIDERY</Header.Content>
                </Header>
                <Button fluid color='yellow' onClick={this.markEmbroidery}> REMOVE EMBROIDERY  </Button>
            </div>
            : <Button fluid color='teal' onClick={this.markEmbroidery}> ADD EMBROIDERY  </Button>

        const wholeUi = this.props.algoliaUser && this.props.algoliaUser.isAdmin
            ? <div><Divider horizontal>{'EMBROIDERY'}</Divider>
                {/* <Button color='yellow' onClick={this.markAutoDesignSend}> AUTO SEND </Button> */}
                {showEmbroideryButtons}
                </div>
            : ''

        return (
            <div>
                {wholeUi}

            </div>

        )
    }
}

export default MarkEmbroidery;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Sales/MarkEmbroidery.js